module.exports = __webpack_public_path__ + "static/media/bathroom.ba6ad887.svg";